module.exports = __webpack_public_path__ + "static/media/CD__0006_0001.ddb8b0b0.png";